export default __webpack_public_path__ + "static/lexcel-logo-78543a1d75eee6d28fb73a6daf9f4278.svg";